var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{staticClass:"pa-0"},[_c('v-chart',{staticClass:"chart-container",attrs:{"option":_vm.chartOptions,"autoresize":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }